import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Contact = () => {
    useEffect(() => {
        document.body.style.backgroundImage = 'url("/images/toriiGate.jpg")';
        document.body.style.backgroundSize = 'cover';
        document.body.style.backgroundPosition = 'center';
        document.body.style.backgroundAttachment = 'fixed';
        document.body.style.backgroundRepeat = 'no-repeat';

        return () => {
            document.body.style.backgroundImage = 'none';
            document.body.style.backgroundAttachment = 'initial';
        };
    }, []);

    return (
        <div className="max-w-3xl mx-auto px-6 py-12">
            <div className="bg-slate-900/70 backdrop-blur-sm rounded-xl p-8 md:p-10 text-gray-200">
                <h1 className="text-3xl font-bold mb-6 text-center text-white">Contact Us</h1>

                <p className="mb-6 leading-relaxed">
                    We would love to hear from you. Whether you have a question about the
                    teachings, a word of encouragement, or simply wish to introduce yourself,
                    you are warmly invited to reach out. Every message is read with care.
                </p>

                <div className="bg-slate-800/60 rounded-lg p-6 mb-6">
                    <h2 className="text-xl font-semibold mb-2 text-white">Email</h2>
                    <p className="leading-relaxed">
                        Write to us at{' '}
                        <a
                            href="mailto:info@buddhawisdom.org"
                            className="text-amber-400 hover:underline"
                        >
                            info@buddhawisdom.org
                        </a>
                        {' '}and we will do our best to respond thoughtfully.
                    </p>
                </div>

                <div className="bg-slate-800/60 rounded-lg p-6 mb-6">
                    <h2 className="text-xl font-semibold mb-2 text-white">Join the Community</h2>
                    <p className="leading-relaxed mb-4">
                        For conversation, questions, and practice alongside others walking
                        the path, our Discord community gathers daily. All are welcome.
                    </p>
                    <Link
                        to="/discord"
                        className="inline-block px-4 py-2 bg-amber-600 hover:bg-amber-500 text-white rounded-full font-semibold transition-colors no-underline"
                    >
                        Visit the Discord Community
                    </Link>
                </div>

                <div className="bg-slate-800/60 rounded-lg p-6">
                    <h2 className="text-xl font-semibold mb-2 text-white">Content Corrections</h2>
                    <p className="leading-relaxed">
                        Notice something in our library or teachings that needs attention?
                        You can send corrections directly through Dharmadhara, the site
                        guide, using the chat aid in the corner of any page. Your care helps
                        keep the Dharma we share accurate and true.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Contact;
